import { Check } from "lucide-react";
import Header from "../components/header";
import { Link } from "react-router-dom";

const Submitted = () => {
  return (
    <>
      <Header />
      <div className="mt-[5%] bg-success bg-opacity-40 flex flex-col items-center shadow-md">

        <div className="bg-primary inline-block rounded-full p-5">
          <Check size={40} color="white" />
        </div>
        <h1 className="text-primary font-bold font-sans text-center text-[60px] mt-3">
          Thank you
        </h1>
        <h3 className="text-primary text-[30px] font-semibold text-center mt-3">
          We got your information, we'll get back to you soon on your given email. 
        </h3>
        <h3 className="text-primary text-[30px] font-semibold text-center mt-3">
         Have a look at our more products 
        </h3>
          <Link to='/products'>
        <button className="hover:shadow-xl  mt-10 px-6 py-3 text-lg font-bold text-white transition-all duration-200 bg-primary rounded-xl  hover:bg-[#602360] hover:duration-300">
        Go Back
        </button>
            </Link>
      </div>
  
    </>
  );
};

export default Submitted;
